import Emitter from "./Emitter";

export default class GameResumed extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler() {
        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId": "rg2xcGameResumed"}), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId": "rg2xcGameResumed"}), "*");
        }
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('displaystatus')) {
            const data = {
                "_type": "ucip.displaystatus.g2wUiStateNotification",
                "busy": false
            }
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
                
            } else {
                this.emitParent(JSON.stringify(data));
            }
        }
    }

    _default() {
        this.emitTop({ wpgaction: "gameResumed" });
        this.emitParent({ wpgaction: "gameResumed.parent" });
        this.emitiOS({ wpgaction: "gameResumed" });
    }
}
